import { reducerWithoutInitialState } from "typescript-fsa-reducers"
import type { KeysOfType, CollectionTypes } from ".."

// Basic reducer guard functions
export function reducerTypeGuard<Model>() {
  return reducerWithoutInitialState<Model>()
}

export function reducerGuard<Model>(key: KeysOfType<CollectionTypes, Model>) {
  return reducerWithoutInitialState<Model>()
}

export function getIdxKeyGuard<Model, PropType>(
  key: string,
  prop: KeysOfType<Model, Array<PropType>>
) {
  return `${key}/${String(prop)}`
}
